import React, { useEffect, useState } from 'react'
import { LandingPageImport } from './Import'
import HeroSection from './section/HeroSection'
import Categories from './section/Categories'
import EventClock from './section/EventClock'
import AboutArea from './section/AboutArea'
import EventPlan from './section/EventPlan'
import Memories from './section/Memories'
import Organizer from './section/Organizer'
import Feedback from './section/Feedback'
import ContactUs from './section/ContactUs'
const { FaArrowUp } = LandingPageImport;

export default function Main() {

    const [progress, setProgress] = useState(0);
    const [visible, setVisible] = useState(false);

    const updateScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        setProgress(scrollPercent);

        // Show when user scrolls more than 100px
        setVisible(scrollTop > 100);
    };

    useEffect(() => {
        window.addEventListener("scroll", updateScroll);
        return () => window.removeEventListener("scroll", updateScroll);
    }, []);

    const radius = 24;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;

    return (
        <>

            <div
                className={`scroll-indicator ${visible ? "show" : ""}`}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
                <svg width="60" height="60" className="svg">
                    <circle className="background" cx="30" cy="30" r={radius} />
                    <circle
                        className="progress"
                        cx="30"
                        cy="30"
                        r={radius}
                        style={{
                            strokeDasharray: circumference,
                            strokeDashoffset: offset,
                        }}
                    />
                </svg>
                <div className="icon-wrapper">
                    <FaArrowUp />
                </div>
            </div>

            <HeroSection />
            <Categories />
            <EventClock />
            <AboutArea />
            <EventPlan />
            <Memories />
            <Organizer />
            <Feedback />
            <ContactUs />
        </>
    )
}